exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".invoiceMarginRight-c2b04{margin-right:40px}.clientTabs-11567{overflow:initial}.clientTabs-11567 .ant-tabs-content{position:static}.modalTitle-a2d91{display:flex;justify-content:space-between}", ""]);

// Exports
exports.locals = {
	"invoiceMarginRight": "invoiceMarginRight-c2b04",
	"clientTabs": "clientTabs-11567",
	"modalTitle": "modalTitle-a2d91"
};